import(/* webpackMode: "eager" */ "/home/interim/frontend/app/consultations/page.tsx");
